import { LessonUpApiService } from '@lessonup/typescript-core/client';
import { Api } from '@lessonup/typescript-core/domain';

export interface SchoolPickerAppService {
  getSchoolPickerSuggestions(params: Api.SchoolPickerRequest): Promise<Api.SchoolPickerResponse>;
}
export default function configureSchoolPickerAppService(api: LessonUpApiService): SchoolPickerAppService {
  function getSchoolPickerSuggestions(params: Api.SchoolPickerRequest): Promise<Api.SchoolPickerResponse> {
    return api.getSchoolSuggestions(params);
  }

  return {
    getSchoolPickerSuggestions,
  };
}
